export const AUTO_FREQUENCY = 'AUTO_FREQUENCY';
export const MANUAL_FREQUENCY = 'MANUAL_FREQUENCY';
export const RENT_PAYMENT = 'Rent payment';
export const MOVE_IN_COSTS_PAYMENT = 'Move-in payment';
export const PAYMENT_METHOD = 'Payment method';
